import "../css/OpeningPrices.css";

import { useNavigate } from "react-router-dom";


export default function OpeningPrices() {
  const navigate = useNavigate();
  return (
    <main className="opening-page">

      <section className="hero-section">
        <h1>Åbningstider & Priser</h1>
        <p>
          Her kan du se vores åbningstider, medlemskaber og priser.
        </p>
      </section>

      <section className="opening-hours">
        <h2>Åbningstider</h2>

        <div className="hours-card">
          <div className="hour-row">
            <span>Mandag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Tirsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Onsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Torsdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Fredag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Lørdag</span>
            <span>Lukket</span>
          </div>

          <div className="hour-row">
            <span>Søndag</span>
            <span>16:00 - 21:00</span>
          </div>
        </div>
      </section>

      <section className="pricing-section">
        <h2>Priser</h2>

        <div className="pricing-grid">
          <div className="price-card premium">
            <h3>Medlem kontingent</h3>
            <p className="price">2000 kr</p>
            <span>Per 6 måned</span>

            <ul>
             <li>Professionel esports coaching</li>
             <li>Træning på faste hold</li>
             <li>Replay reviews & feedback</li>
             <li>Adgang til Discord community</li>
             <li>Deltagelse i turneringer</li>
             <li>Fokus på teamwork & kommunikation</li>
             <li>Udvikling for både begyndere og øvede</li>
            </ul>

            <button onClick={() => navigate("/signup-academy")}>
            Tilmeld
            </button>
          </div>

        </div>
      </section>

    </main>
  );
}